import { render, staticRenderFns } from "./CheckoutSettings.vue?vue&type=template&id=14ed7d4a&"
import script from "./CheckoutSettings.vue?vue&type=script&lang=js&"
export * from "./CheckoutSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports